export default "__VITE_PUBLIC_ASSET__50d1540b__"